import i18n from "@/i18n";
import { Key } from "./Key";

export const languageOptions = [
    {
        label: i18n.global.t('components.login.english'),
        key:Key.language.english
    },
    {
        label: i18n.global.t('components.login.german'),
        key:Key.language.default
    },
]